import { render } from "./LayoutSnackbar.vue?vue&type=template&id=a2be3bb8&ts=true"
import script from "./LayoutSnackbar.vue?vue&type=script&lang=ts"
export * from "./LayoutSnackbar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/blueflamehaze/Documents/Projects/certificates/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__